import React, { Component } from 'react';
import {Subtopic, Footer,TextHolder, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



export class ChapterNinetyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>




        <div className="block-outer block-outer-textholder">
          <div className="block-inner block-inner-textholder">
            <div className="text-title-holder">
              <p>{ this.props.textTitle }</p>
            </div>
            <div className="text-holder">
              <p>SEA’s crypto scene is booming. Startups like OmiseGo, Coins.ph, and others cater to the tech-savvy but often unbanked consumers in the region with blockchain-based fintech solutions. 2018 saw the launch of
              <a href="https://techcrunch.com/2018/08/10/golden-gate-ventures-lunex-crypto/"> SEA’s first dedicated crypto fund</a>, LuneX Ventures, which will help the ecosystem grow at an even more rapid pace. As of this writing, the spinoff of Singapore’s Golden Gate Ventures is targeting to raise a $10 million fund to focus on crypto. </p>

            </div>
          </div>
        </div>

        <div className="block-outer block-outer-textholder">
          <div className="block-inner block-inner-textholder">
            <div className="text-title-holder">
              <p>{ this.props.textTitle }</p>
            </div>
            <div className="text-holder">
              <p>Where ICOs are concerned, Singapore will remain the leader. However, expect Central Banks and stock exchanges to introduce new rules to supervise this new way of raising funds. In April, the Vietnamese government
              <a href="https://www.straitstimes.com/asia/se-asia/vietnam-vows-cryptocurrency-crackdown-after-864m-fraud"> announced a crackdown on crypto </a>
              after one fraudulent ICO scammed consumers out of $660 million. It remains to be seen whether governments will help or hinder the crypto economy in SEA in the long run.</p>

            </div>
          </div>
        </div>
                <TextHolder />


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/91.js